<template>
  <div class="selectForYou" v-if="showList.length" mg-stat-show="flag=610" mg-stat-lob="smod=recommend">
    <p class="module-title">{{info.module_name}}</p>
    <!-- <p class="right-tip">向左滑动查看更多</p> -->
    <div class="wrapper">
      <div class="first" v-if="showList[0]" @click="jump(showList[0])">
        <p class="item-title">{{ showList[0].goods_name }}</p>
        <p class="item-credits">
          <span class="num">{{ showList[0].exchange_integral }}</span><span class="plain-txt">积分</span><span v-if="Number(showList[0].exchange_price) > 0"><span class="plus">+</span><span class="num">{{ parseFloat(showList[0].exchange_price) }}</span><span class="plain-txt">元</span>
          </span>
          <!-- <i></i> -->
        </p>
        <p class="btn">立刻兑换</p>
        <img :src="showList[0].original_img" alt="">
      </div>
      <div class="others-wrapper">
        <swiper :options="swiperOptions" class="swiper-box">
          <swiper-slide
            v-for="(_, slideIndex) in Math.ceil((showList.length - 1) / 2)"
            :key="slideIndex"
            class="slide-wrapper"
          >
            <div 
              class="others"
              v-for="(item, index) in showList.slice(1).slice(slideIndex * 2, slideIndex * 2 + 2)"
              :key="item.goods_id"
              :class="{ 'first-item': index === 0, 'second-item': index === 1 }"
              @click="jump(item)"
            >
              <div class="text-area">
                <p class="item-title">{{ item.goods_name }}</p>
                <p class="item-credits">
                  <span class="num">{{ item.exchange_integral }}</span><span class="plain-txt">积分</span>
                  <span v-if="Number(item.exchange_price) > 0">
                    <span class="plus">+</span><span class="num">{{ parseFloat(item.exchange_price) }}</span><span class="plain-txt">元</span>
                  </span>
                </p>
                <p class="btn">立刻兑换</p>
              </div>
              <img :src="item.original_img" alt="">
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="swiper-pagination-1"
          slot="pagination"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getModuleGoodsList } from '@/utils/service'
import { getHaoWuUrl } from '@/utils/mUtil'
import { loginMixin } from '@/utils/mixin'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  mixins: [loginMixin],
  data() {
    return {
      info: '',
      list: [],
      swiperOptions: {
        direction: 'vertical',
        autoplay: true,
        // height: '100%',
        // slidesPerView: 2,
        spaceBetween: 24,
        pagination: {
          el: '.swiper-pagination-1',
          clickable: true,
          // renderBullet(index, className) {
          //   return `<span class="${className} swiper-pagination-bullet-custom"></span>`
          // },
        },
        on: {
          init() {
            const pxToRem = px => (px / 75) + 'rem';
            this.$wrapperEl.css('height', pxToRem(358));
          }
        }
      }
    }
  },
  created() {
    this.moduleList.forEach(val => {
      if (val.type == 1) {
        this.info = val
      }
    })
    this.getModuleGoodsList()
  },
  methods: {
    async getModuleGoodsList() {
      try {
        const data = await getModuleGoodsList({
          module_id: this.info.module_id,
          p: 1,
        })
        this.list = data.records
      } catch (error) {
        console.log('getModuleGoodsList' + error)
      }
    },
    jump(item) {
      MgStat.send(
        'click',
        {},
        {
          cntp: 'score_newHome',
          mod: 'recommend',
          cont: '点击为你推荐模块',
        }
      )

      location.href = getHaoWuUrl(item.goods_id, '', 'credits')
    },
  },
  name: 'SelectForYou',
  props: {
    moduleList: {
      type: Array,
      default: [],
    },
  },
  components: { swiper, swiperSlide },
  computed: {
    showList() {
      return this.list.slice(0, 5)
    },
    proids() {
      return this.showList.map(v => v.goods_id).join('#')
    },
  },
}
</script>

<style scoped lang="less">
.selectForYou {
  position: relative;
  padding-top: 36px;
  background: #FFFFFF;
  border-radius: 36px 36px 36px 36px;
  text-align: left;
  overflow: hidden;
  height: 474px;
  
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    margin-left: 32px;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    width: 128px;
    height: 40px;
    background: rgba(0,0,0,0.2);
    border-radius: 38px 38px 38px 38px;
  }

  .module-title {
    // font-family: AlimamaFangYuanTiVF-Thin;
    font-weight: 600;
    padding-left: 36px;
    margin-bottom: 20px;
  }
  
  .swiper-box {
    height: 100%;
    position: relative;
  }
  
  .swiper-pagination-1 {
    position: absolute;
    right: -12px;
    top: 152px;
    left: auto;
    width: auto;
    display: flex;
    flex-direction: column;

    /deep/ .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      margin: 0 0 8px 0;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 36px;
      opacity: 1;

      &:last-child {
        margin-bottom: 0;
      }
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #FF4500;
    }
  }


  .wrapper {
    padding-left: 24px;
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 30px;
    white-space: nowrap;
    
    i {
      display: inline-block;
      width: 34px;
      height: 34px;
      vertical-align: middle;
      margin-left: 5px;
      background: url(../../../assets/star.png) center/contain no-repeat;
    }
    
    .item-title {
      font-weight: 400;
      font-size: 28px;
      color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 36px 54px 17px 30px;
    }
    
    .item-credits {
      margin-top: 0px;
      font-size: 25px;
      height: 32px;
      // line-height: 28px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;

      .num {
        font-family: DIN Alternate, DIN Alternate;
        font-weight: bold;
        font-size: 26px;
        color: #FF4500;
        padding-left: 4px;
      }
      .plain-txt {
        font-weight: 400;
        font-size: 22px;
        color: rgba(0, 0, 0, 0.4);
      }
      .plus {
        font-weight: 400;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.4);
        padding: 0 4px;
      }
    }
    
    .first {
      position: relative;
      width: 303px;
      height: 358px;
      border-radius: 24px 24px 24px 24px;
      background: linear-gradient(224deg, rgba(255,255,255,0) 0%, #FFFFFF 100%), #FFCBCB;
      display: inline-block;
      vertical-align: top;
      // padding-top: 26px;
      // background: url(../../../assets/first-bg.png) center/contain no-repeat;
    
      
      img {
        position: absolute;
        bottom: 16px;
        right: 20px;
        display: block;
        width: 150px;
        height: 150px;
        object-fit: cover;
      }
      
      .item-credits {
        padding-left: 24px;
        margin-top: 0;
      }
    }
    
    .others-wrapper {
      margin-left: 24px;
      display: inline-block;
      white-space: normal;
      position: relative;
    }

    .others {
      position: relative;
      width: 303px;
      // height: 167px;
      padding-left: 24px;
      padding-top: 23px;
      padding-bottom: 24px;
      // padding-top: 35px;
      // margin-left: 18px;
      border-radius: 24px;

      &.first-item {
        background: linear-gradient(224deg, rgba(255,255,255,0) 0%, #FFFFFF 100%), #C7F9FF;
        margin-bottom: 24px;
      }

      &.second-item {
        background: linear-gradient(224deg, rgba(255,255,255,0) 0%, #FFFFFF 100%), #F4FFCC;
      }

      .item-title {
        width: 219px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0;
      }

      .text-area {
        // width: 172px;
        display: inline-block;
        color: #ffffff;
        vertical-align: top;
        margin-left: 18px;
        margin-right: 8px;
      }
      img {
        position: absolute;
        top: 75px;
        right: 12px;
        display: inline-block;
        width: 80px;
        height: 80px;

        object-fit: cover;
      }
      .btn {
        margin-left: 0;
      }
    }
  }
  .right-tip {
    position: absolute;
    right: 36px;
    top: 36px;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
  }
}
</style>
